import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Formik, FormikProps } from 'formik';
// @ts-ignore
// @ts-ignore
// @ts-ignore
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import Plot from 'react-plotly.js';
import 'react-pivottable/pivottable.css';
import { ReportService } from '../../api/report-services';
import { BackgroundService } from '../../api/background-service';
import { getValidation } from '../../models/validations/report-enrollments';
import { IAction, IAppState } from '../../models/action/core';
import { Notification } from '../../components/notification/main';
import Moment from 'moment';
import queryString from 'querystring';
import { SelectAsync, SelectNoneAsync } from '../../components/input/select/main';
import { IEnrollmentReportsState } from '../../models/components/IEnrollmentReportsState';
import { IEnrollmentReportsFormikProps } from '../../models/components/IEnrollmentReportsFormikProps';
import { IEnrollmentReportsProps } from '../../models/components/IEnrollmentReportsProps';
import { ReportType } from '../../models/enums/ReportType';
import { User } from '../../components/filters/user';
import { VirtualClassType } from '../../models/enums/VirtualClassType';
import { DatetimeFormik } from '../../components/input/date-time/date-time-formik';
import { ActivityType } from '../../components/filters/activityType';
import { EnrollmentStatus } from '../../components/filters/enrollmentStatus';
import { IFilter } from '../../models/action/calendar';
import { Button } from '../../components/ui-elements/main';

const T = Translator.create();
const _logger = Log.create('Reports Page');
let _common: Common;

const PlotlyRenderers = createPlotlyRenderers(Plot);
const _reportService = new ReportService();
const _backgroundService = new BackgroundService();

const options = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
];

const customStyles: any = {
    control: (styles: any) => ({
        ...styles,
        background: 'white',
        color: 'white',
        boxShadow: 'none',
        borderColor: '#ccc',
        borderWidth: 0,
        borderBottomWidth: 1,
        borderRadius: 0
    }),
};

class GeneralActivityReports extends React.Component<IEnrollmentReportsProps, IEnrollmentReportsState> {
    public state: IEnrollmentReportsState = {
        isExpertMode: false,
        reportData: [],
        selectCourse: '',
        isReportShow: false,
        selectedOption: [{ value: 10, label: '10' }],
        _colOrder: '',
        _rowOrder: '',
        _cols: [],
        _rows: [],
        _tempCols: [],
        _tempRows: [
            'Kullanıcı Adı',
            'Adı Soyadı',
            'Ders Adı',
            'Şube Adı',
            'Aktivite Tipi',
            'Aktivite Adı',
            'Durumu',
            'Tamamlama Tarihi',
            'Notu',
            'Canlı Katılım Oranı',
            'Tekrar İzleme Süresi'
        ],
        _nameRows: [
            T.t('r_username_title'),
            T.t('r_name_surname'),
            T.t('r_activity_name'),
            T.t('r_course_name'),
            T.t('r_gen_class_name'),
            T.t('r_activity_type'),
            T.t('r_status'),
            T.t('r_note'),
            T.t('r_gen_completionDate'),
            T.t('r_replay_time'),
            T.t('r_live_participation_rate')
        ],
        guid: '',
        isSaveModelOpen: false,
        templateName: '',
        isUpdate: false,
        clear: false,
        submitValues: null,
        isSelected: false,
        filters: {
            page: 1,
            take: 10,
            total: 0
        },
    };
    constructor(props: IEnrollmentReportsProps) {
        super(props);
        this.onChangePivot = this.onChangePivot.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        _common = new Common();
    }

    public onChangePivot(s: any) {
        delete s.data;
        this.setState(s);
        this.setState({ _cols: s.cols, _rows: s.rows, _rowOrder: s.rowOrder, _colOrder: s.colOrder });

    }

    onSubmit = async (values: IEnrollmentReportsFormikProps) => {

        this.setState({ isReportShow: true });
        this.setState({ isSelected: true });
        this.setState({ reportData: [] });
        if (values.dateRange) {
            if (!values.dateRange.includes('-')) {
                Notification.setNotification('error', T.t('dateRange_error'), 'topRight');
            } else {
                values.beginDate = values.dateRange
                    ? Moment(values.dateRange.substring(0, 10), _common.findDateFormat(this.props.userPreferences!)).format(
                        window.appSettings.DefaultDateFormatApi
                    )
                    : values.beginDate;

                values.endDate = values.dateRange
                    ? Moment(values.dateRange.substring(13, values.dateRange.length), _common.findDateFormat(this.props.userPreferences!))
                        .endOf('day')
                        .format(window.appSettings.DefaultDateFormatApi)
                    : values.endDate;
            }
        } else {
            values.beginDate = '';
            values.endDate = '';
        }

        try {

            if (this.state.guid === ReportType.StandartReport) {
                const tempRowsData = this.state._tempRows.concat(values.rowNameList);
                values.rowNames = tempRowsData;
                this.setState({ submitValues: values });
                values.take = this.state.filters.take;
                values.skip = this.state.filters.skip;
            }

            const reportData = await _reportService.RequestEnrollmentData(values);
            const reportJson = await reportData.json();

            this.setState({ reportData: reportJson, formikValues: values });
        } catch {
            Notification.setNotification('error', T.t('r_report_page_get_error_message'), 'topRight');
        }
    };



    getReportTemplates = async () => {
        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);
        this.setState({ guid: params.templateId });
        if (params.templateId !== ReportType.PivotTableReport && params.templateId !== ReportType.StandartReport) {
            const reportData = await _reportService.RequestReportChoises(params.templateId);
            const data = await reportData.json();
            if (data.cols.length > 0 || data.rows.length > 0) {
                this.setState({ _tempCols: data.cols, _tempRows: data.rows, templateName: data.templateName });
            }
        }
    };

    public componentDidMount() {
        this.getReportTemplates();
    }

    public onChangeSelectCondition() {
      return ;
    }

    render() {
        const initialFormValues: IEnrollmentReportsFormikProps = {
            rowNames: [],
            rowNameList: [],
            selectedCourses: [],
            termIds:[],
            selectedBranches: [],
            selectedClasses: [],
            selectedUsers: [],
            selectedActivities: [],
            selectedActivityTypes: [],
            selectedStatuses: [],
            take: 100,
            dateRange: '',
            dateFilter: 'CreatedDate'
        };

        return (
            <div>
                <div className="student-course" style={{ paddingBottom: '1em', height: "100vh" }}>
                    <div className="question-filter">
                        <div
                            className="container"

                        >
                            <div className="row align-items-center">
                                <div className="col-md-4">
                                    <h6 className="mb-3 mb-md-0">{T.t('r_report_general_activity')}</h6>
                                </div>
                                <div className="col-md-8 text-md-right">
                                    <div className="options d-inline-flex align-items-center">


                                        <Button
                                            data-toggle="modal"
                                            data-target="#preview-question"
                                            button_type='primary'
                                            size='medium'
                                            text={T.t('r_gen_download_full_data')}
                                            materialicon='arrow_downward'
                                            iconPosition='left'
                                        />
                                    </div>
                                </div>
                            </div>
                            <Formik initialValues={initialFormValues} validationSchema={getValidation} onSubmit={this.onSubmit}>
                                {formik => {
                                    return (
                                        <form   key={'activity_report'}>
                                            <div className="filter-fields mt-4">
                                                <div className="row">
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_gen_term_select')}</label>
                                                        <SelectAsync
                                                            isMulti={true}
                                                            className='k365-select'
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{ SearchedText: '', SelectedIds: formik.values.termIds, Take: 5 }}
                                                            placeHolder={T.t('r_gen_term_select')}
                                                            url={'api/examsession/terms/get'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'termIds'}
                                                            value={formik.values.termIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.termIds}
                                                            touched={formik.touched.termIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_gen_user_select')}</label>
                                                        <User
                                                                formik={formik}
                                                                value={formik.values.selectedUsers}
                                                                errors={formik.errors.selectedUsers}
                                                                touched={formik.touched.selectedUsers}
                                                                name={'selectedUsers'}
                                                                courseIds={formik.values.selectedCourses}
                                                                classIds={formik.values.selectedClasses}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_gen_course_select')}</label>
                                                        <SelectAsync
                                                            isMulti={true}
                                                            className='k365-select'
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{ SearchedText: '', GetTypes: 'Course', Skip: 0, Take: 5 }}
                                                            placeHolder={T.t('r_gen_course_select')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'courseIds'}
                                                            value={formik.values.selectedCourses}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.selectedCourses}
                                                            touched={formik.touched.selectedCourses}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_activity_type')}</label>
                                                        <ActivityType
                                                                formik={formik}
                                                                value={formik.values.selectedActivityTypes}
                                                                errors={formik.errors.selectedActivityTypes}
                                                                touched={formik.touched.selectedActivityTypes}
                                                                name={'selectedActivityTypes'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_enrollment_status')}</label>
                                                        <EnrollmentStatus
                                                                formik={formik}
                                                                value={formik.values.selectedStatuses}
                                                                errors={formik.errors.selectedStatuses}
                                                                touched={formik.touched.selectedStatuses}
                                                                name={'selectedStatuses'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_gen_start_date')}</label>
                                                        <DatetimeFormik
                                                        className='k365-select'
                                                        name={'customProperty5Date'}
                                                        formik={formik}
                                                        placeHolder={T.t('r_gen_start_date')}
                                                        datePickerId={'startDate'}
                                                        mode="single"
                                                        static={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_gen_end_date')}</label>
                                                        <DatetimeFormik
                                                        className='k365-select'
                                                        name={'customProperty5Date'}
                                                        formik={formik}
                                                        placeHolder={T.t('r_gen_end_date')}
                                                        datePickerId={'endDate'}
                                                        mode="single"
                                                        static={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_select_program')}</label>
                                                        <SelectAsync
                                                            isMulti={false}
                                                            isSearchable={true}
                                                            className='k365-select'
                                                            requestType={'post'}
                                                            parameter={{
                                                                Skip: 0,
                                                                Take: 10,
                                                                GetTypes: 'Program',
                                                            }}
                                                            placeHolder={T.t('r_select_program')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={true}
                                                            name={'targets'}
                                                            hasLocalization={true}
                                                            isClearable={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_select_faculty')}</label>
                                                        <SelectAsync
                                                            className='k365-select'
                                                            isMulti={false}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                Skip: 0,
                                                                Take: 10,
                                                                GetTypes: 'Unit',
                                                            }}
                                                            placeHolder={T.t('r_select_faculty')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={true}
                                                            name={'targets'}
                                                            hasLocalization={true}
                                                            isClearable={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_select_group')}</label>
                                                        <SelectAsync
                                                            className='k365-select'
                                                            isMulti={false}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                Skip: 0,
                                                                Take: 10,
                                                                GetTypes: 'Group',
                                                            }}
                                                            placeHolder={T.t('r_select_group')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={true}
                                                            name={'targets'}
                                                            hasLocalization={true}
                                                            isClearable={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                            <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_activity_name')}</label>
                                                        <SelectAsync
                                                            isMulti={false}
                                                            isSearchable={true}
                                                            className='k365-select'
                                                            requestType={'post'}
                                                            parameter={{
                                                                Skip: 0,
                                                                Take: 10,
                                                                GetTypes: 'Activity',
                                                            }}
                                                            placeHolder={T.t('r_activity_name')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={true}
                                                            name={'targets'}
                                                            hasLocalization={true}
                                                            isClearable={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_show_passive_user')}</label>
                                                        <SelectAsync
                                                            isMulti={false}
                                                            className='k365-select'
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                Skip: 0,
                                                                Take: 10,
                                                                GetTypes: 'PassiveUsers',
                                                            }}
                                                            placeHolder={T.t('r_show_passive_user')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={true}
                                                            name={'targets'}
                                                            hasLocalization={true}
                                                            isClearable={true}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className="col col-md-4 col-sm-6 col-6">
                                                        <div className="k365-input date-picker">
                                                        <label className='input-label'>{T.t('r_gen_questionBank_questionType_ordering')}</label>
                                                        <SelectNoneAsync
                                                            className='k365-select'
                                                                    name={'questionTypes'}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    setOptions={[
                                                                        { value: 0, label: T.t('r_default_by_name_organization') },
                                                                        { value: 3, label: T.t('r_default_by_group_organization') },
                                                                        { value: 2, label: T.t('r_default_by_name') },
                                                                        { value: 4, label: T.t('r_default_by_group') },
                                                                        { value: 1, label: T.t('r_default_by_name_and_organization') },
                                                                        { value: 5, label: T.t('r_default_by_group_and_organization') }
                                                                    ]}
                                                                    // tslint:disable-next-line:jsx-no-lambda
                                                                    onChange={(e: any) => this.onChangeSelectCondition()}
                                                                    isTouched={formik.setFieldTouched}
                                                                    // setSelectValue={this.props.isUpdate ? [this.props.formik.values.virtualClassType] : ''}
                                                                    placeHolder={T.t('r_gen_questionBank_questionType_ordering')}
                                                                    isClearable={true}
                                                                />
                                                        </div>
                                                    </div>
                                                    <div className='col' >
                                                        <div className="ml-auto text-right mx-3 mb-2">

                                                            <Button
                                                                button_type='primary'
                                                                size='medium'
                                                                text={T.t('r_gen_search')}
                                                                materialicon='search'
                                                                iconPosition='left'
                                                            />
                                                            {/* <a
                                                                // tslint:disable-next-line:jsx-no-lambda
                                                                onClick={this.clearFilters.bind(this, formik)} className="btn report_btn ml-auto">{T.t('r_gen_reports_set_filter')}</a> */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </form>
                                    );
                                }}
                            </Formik>
                            {this.state.guid !== ReportType.StandartReport && (
                                <div className="question-list mt-3">
                                    <div className="info-box">
                                        <p>
                                            {T.t('r_gen_report_generl_activity')}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IEnrollmentReportsProps): IEnrollmentReportsProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IEnrollmentReportsProps =  {...ownProps, ... {
        userPreferences: state.profile.userPreferences.preferences,
        culture: state.login.identitiy.culture
    }};

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.profile.userPreferences === prev.profile.userPreferences;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CEnrollmentReports = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(GeneralActivityReports);

export default CEnrollmentReports;
